// extracted by mini-css-extract-plugin
export var quillEditor = "_kd-1";
export var variable = "_kd-0";